import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetClassEvent } from './asset-class.event';
export class AssetsImportedEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetsImportedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetsImportedEvent.type = 'com.treeplotter.api.asset-class.assetsImported.v1';
EventRegistry.register(AssetsImportedEvent.type, AssetsImportedEvent);
//# sourceMappingURL=assets-imported.event.js.map